var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.userIsAdmin)?_c('ParkedSpecificationValueAdmin',{attrs:{"parked-number":_vm.specification.value}}):[_vm._v(" "+_vm._s(_vm.specification.value)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }